import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`This library was built by the community but it's being maintained by the PostHog core team since v1.0.0. Thank you to `}<a parentName="p" {...{
          "href": "https://github.com/nkezhaya"
        }}>{`Nick Kezhaya`}</a>{` for building it originally. Thank you to `}<a parentName="p" {...{
          "href": "https://github.com/martosaur"
        }}>{`Alex Martsinovich`}</a>{` for contributing v2.0.0.`}</p>
    </blockquote>
    <p>{`The package can be installed by adding `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` to your list of dependencies in `}<inlineCode parentName="p">{`mix.exs`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`def deps do
  [
    {:posthog, "~> 2.0.0"}
  ]
end
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-elixir",
        "metastring": "file=config/config.exs",
        "file": "config/config.exs"
      }}>{`config :posthog,
  enable: true,
  api_host: "<ph_client_api_host>",
  api_key: "<ph_project_api_key>",
  in_app_otp_apps: [:my_app]
`}</code></pre>
    <p>{`You can see all the available configuration options in the `}<a parentName="p" {...{
        "href": "https://hexdocs.pm/posthog/PostHog.Config.html"
      }}>{`PostHog.Config`}</a>{` module.`}</p>
    <p>{`Optionally, you might want to enable the `}<a parentName="p" {...{
        "href": "https://hexdocs.pm/posthog/PostHog.Integrations.Plug.html"
      }}>{`Plug integration`}</a>{` to automatically capture events from your Plug-based applications including Phoenix.`}</p>
    <h4 {...{
      "id": "developmenttest-mode"
    }}>{`Development/Test mode`}</h4>
    <p>{`For a test environment, you can pass in `}<inlineCode parentName="p">{`test_mode: true`}</inlineCode>{` value to the config. This causes events to be dropped instead of sent to PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      